import { Flex, Image, Layout } from "antd";
import { Content, Header } from "antd/es/layout/layout";
import { Outlet, useNavigate } from "react-router-dom";

const WebappPage = ({ }) => {
    const navigate = useNavigate();
    return (
        <Layout>
            <Content >
                <Outlet />
            </Content>
        </Layout >
    )
}
export default WebappPage;